import { Component, Input, output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ToastService } from '../toast/toast';
import { AdminPanelComponent } from './admin-panel.component';

/**
 * Admin-only debug component for unit pages.
 * Collapsed by default into a subtle toggle bar.
 * Expands to show unit tags, admin links, and optional validation results.
 */
@Component({
    standalone: true,
    selector: 'abs-admin-unit-debug',
    imports: [CommonModule, RouterModule, IonicModule, AdminPanelComponent],
    template: `
        <abs-admin-panel label="Admin">
            <div class="admin-panel-actions">
                <a class="admin-panel-btn" [routerLink]="['/admin', unitGameId, 'entity', 'units', unitId]">
                    <ion-icon name="create-outline"></ion-icon>
                    Edit Unit
                </a>
                @if (validateUnit) {
                    <button class="admin-panel-btn" (click)="validateUnit.emit()">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                        Validate
                    </button>
                }
            </div>

            @if (tags?.length) {
                <div class="admin-panel-tags">
                    @for (tag of tags; track tag) {
                        <span class="admin-panel-tag">{{ tag }}</span>
                    }
                </div>
            }

            @if (validationResults) {
                <pre class="admin-panel-pre" (click)="copyToClipboard()">{{ validationResults | json }}</pre>
            }
        </abs-admin-panel>
    `,
    styles: [``],
    encapsulation: ViewEncapsulation.None
})
export class AdminUnitDebugComponent {
    /** Tags associated with the unit (for display purposes) */
    @Input() tags: string[] = [];

    /** The game ID for routing to admin panel */
    @Input() gameId!: string;

    /** The unit's template game ID (may differ from force game ID for merged games) */
    @Input() unitGameId!: string;

    /** The unit template ID for routing to admin panel */
    @Input() unitId!: string;

    /** Validation results to display (game-specific format) */
    @Input() validationResults: any;

    @Input() canValidate = false;

    /** Emitted when the validate button is clicked - handled by parent component */
    validateUnit = output<void>();

    constructor(private toast: ToastService) {}

    copyToClipboard() {
        const text = JSON.stringify(this.validationResults, null, 4);
        navigator.clipboard
            .writeText(text)
            .then(() => {
                this.toast.showToast('', 'Copied to clipboard', { color: 'success' });
            })
            .catch((err) => {
                this.toast.showToast('', 'Error copying to clipboard', { color: 'danger' });
            });
    }
}
